// src/broadcast/schemas/base.schema.ts

import { z } from 'zod'

/**
 * Schema for broadcast operation types
 */
export const BroadcastOperationSchema = z.enum(['INSERT', 'UPDATE', 'DELETE'])

/**
 * Schema for broadcast event types
 */
export const BroadcastEventTypeSchema = z.enum([
  'message',
  'notification',
  'matching',
  'system',
  'image_generation'
])

/**
 * Factory function to create broadcast payload schemas
 * @param recordSchema - Zod schema for the record type
 * @param eventType - Literal type for the event
 */
export function createBroadcastPayloadSchema<T extends z.ZodTypeAny>(
  recordSchema: T,
  eventType: z.ZodLiteral<string>
) {
  return z.object({
    id: z.string(),
    timestamp: z.number(),
    message: z.string(),
    metadata: z.object({
      event: BroadcastOperationSchema,
      type: eventType,
      meta: z.object({
        id: z.string()
      }),
      payload: z.object({
        id: z.string(),
        old_record: recordSchema.nullable(),
        operation: BroadcastOperationSchema,
        record: recordSchema,
        schema: z.string(),
        table: z.string(),
      }),
    }),
  })
}

/**
 * Infer TypeScript type from a broadcast payload schema
 */
export type InferBroadcastPayload<T extends z.ZodTypeAny> = z.infer<T>
